/* スライダー */
// let model_item_slider = new Swiper('.model_item_slider', {
//     loop: true,
//     slidesPerView: 1,
//     spaceBetween: 80,
//     speed: 500,
//     pagination: {
//         el: ".swiper-pagination",
//         clickable: true
//     },
//     breakpoints: {
//         768: {
//             slidesPerView: 1,
//         }
//     }
// });
let img_slider = new Swiper('.img_slider', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 60,
    speed: 500,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true
              },
    breakpoints: {
        768: {
            slidesPerView: 3,

        }
    }
});